import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type navigationState = {
	navigation: string;
	alert: boolean;
};

const initialState: navigationState = {
	navigation: '',
	alert: false,
};

export const navigationSlice = createSlice({
	name: 'navigation',
	initialState,
	reducers: {
		setNavigation: (state, action: PayloadAction<string>) => {
			state.navigation = action.payload;
		},
		setAlert: (state, action: PayloadAction<boolean>) => {
			state.alert = action.payload;
		},
	},
});

export const { setNavigation, setAlert } = navigationSlice.actions;

export default navigationSlice.reducer;
